import React from 'react'
import {
  List,
  DatagridConfigurable,
  TextField,
  ShowButton,
  FilterButton,
  ExportButton,
  DateField,
} from 'react-admin';

const OrganisationList = (props) => {
  const actions = (
    <>
      <FilterButton />
      <ExportButton />
    </>
  );

  return (
    <List {...props} perPage={50} sort={{ field: 'id', order: 'DESC' }} actions={actions}>
      <DatagridConfigurable bulkActionButtons={false}>
        <TextField source="id" label="ID" />
        <TextField source="name" />
        <TextField source="email_domain" label="Email domain" />
        <TextField source="join_policy" label="Join policy" />
        <DateField source="creation_date" label="Created at" showTime />
        <ShowButton />
      </DatagridConfigurable>
    </List>
  );
};

export default OrganisationList;
